import * as React from 'react';
import RawHtml from 'react-raw-html';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  exceptionTypes,
  fetchUserInfoDeferred,
  logException,
  LogException,
  productInfoDeferred,
  UserEntersLoyaltyCode,
  userEntersLoyaltyCode,
  validateLoyaltyCode,
  ValidateLoyaltyCodeDeferred
} from '../actions/Actions';
import { IProductInfo, IReferer, IState } from '../CustomTypes';
import { setRedirectUrlInLocalStorage } from '../fastflowUtils';
import { YesPlease } from '../input-components/InputComponents';
import { sccPulseTrackPageView } from '../PulseUtils';
import './Product.scss';

export interface IProductPageParamProps {
  productInfo: IProductInfo;
  referer: IReferer;
  source?: string;
  medium?: string;
  content?: string;
  campaign?: string;
  term?: string;
  valid: boolean;
  __rct?: string;
}

export interface IProductPageActionProps {
  logException: LogException;
  userEntersLoyaltyCode: UserEntersLoyaltyCode;
  validateLoyaltyCode: ValidateLoyaltyCodeDeferred;
}

export interface IProductPageState {
  cardNumber: string;
  submitted: boolean;
}

export interface IProductPageProps
  extends IProductPageParamProps,
    IProductPageActionProps {}

export class ProductPage extends React.Component<
  IProductPageProps,
  IProductPageState
> {
  constructor(props: IProductPageProps) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleChoice = this.handleChoice.bind(this);
    this.state = { cardNumber: '', submitted: false };
  }

  public componentDidMount() {
    setRedirectUrlInLocalStorage({
      __rct: this.props.__rct,
      redirectUri: this.props.referer.redirectUri,
      referer: this.props.referer.referer,
      utmCampaign: this.props.campaign,
      utmContent: this.props.content,
      utmMedium: this.props.medium,
      utmSource: this.props.source,
      utmTerm: this.props.term
    });
    const { logException } = this.props;
    productInfoDeferred.promise.then(product => {
      const eventName = 'Viewed product page form';
      fetchUserInfoDeferred.promise
        .then(user => {
          sccPulseTrackPageView(product, user, eventName);
        })
        .catch(e => {
          logException(exceptionTypes.EXCEPTION, e);
          sccPulseTrackPageView(product, {}, eventName);
        });
    });
  }

  public render() {
    if (!this.props.productInfo) {
      return null;
    }
    const { imageurl, text1, text3, loyaltyPartner } = this.props.productInfo;
    return (
      <div className="product-presentation container">
        <div className="row">
          <div className="col-xs-12  removepadding">
            <img className="img-responsive productimage" src={imageurl} />
          </div>
          {!this.props.valid && loyaltyPartner && this.state.submitted && (
            <div className="col-xs-12 validation-messages">
              <div className="alert alert-error">
                Kan ikke finne fordelskonto
              </div>
            </div>
          )}
          <div className="col-xs-12 desktoptext">
            <RawHtml.p>{text1}</RawHtml.p>
            <br />
          </div>

          {loyaltyPartner && (
            <div className="col-xs-6 col-xs-offset-3 inputField form-group removepadding">
              <input
                type="tel"
                className="loyaltyCodeLabel form-control"
                autoComplete="false"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck={false}
                onChange={e => this.props.userEntersLoyaltyCode(e.target.value)}
                onBlur={e => this.handleChange(e)}
              />
              <label>{loyaltyPartner.placeholder}</label>
            </div>
          )}
          {loyaltyPartner && loyaltyPartner.name === 'CHOICE_CLUB' && (
            <div className="col-xs-6 col-xs-offset-3 inputField form-group removepadding">
              <input
                type="tel"
                className="loyaltyCodeLabel form-control"
                autoComplete="false"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck={false}
                onBlur={e => this.handleChoice(e)}
              />
              <label>Telefon</label>
            </div>
          )}
          <div className="col-xs-12 order-button-and-text">
            <YesPlease />
            <RawHtml.p>{text3}</RawHtml.p>
          </div>
        </div>
      </div>
    );
  }

  public handleChange = (e: any) => {
    const { loyaltyPartner } = this.props.productInfo;
    const val = e.target.value;
    if (loyaltyPartner.name === 'CHOICE_CLUB') {
      this.setState({ cardNumber: val });
    } else {
      if (
        val.length <= loyaltyPartner.maxLength &&
        val.length >= loyaltyPartner.minLength
      ) {
        this.props.validateLoyaltyCode(loyaltyPartner.name, val);
        this.setState({ submitted: true });
      }
    }
  };

  public handleChoice = (e: any) => {
    const { loyaltyPartner } = this.props.productInfo;
    const val = e.target.value;
    this.props.validateLoyaltyCode(
      loyaltyPartner.name,
      this.state.cardNumber,
      val
    );
    this.setState({ submitted: true });
  };
}

export default connect(
  (state: IState) =>
    ({
      __rct: state.router.location.query.__rct,
      campaign: state.router.location.query.utm_campaign,
      content: state.router.location.query.utm_content,
      medium: state.router.location.query.utm_medium,
      productInfo: state.productInfo,
      referer: state.referer,
      source: state.router.location.query.utm_source,
      term: state.router.location.query.utm_term,
      valid: state.userInfo.valid
    } as IProductPageParamProps),
  dispatch =>
    bindActionCreators(
      { logException, userEntersLoyaltyCode, validateLoyaltyCode },
      dispatch
    ) as IProductPageActionProps
)(ProductPage);



// WEBPACK FOOTER //
// ./src/page-components/Product.tsx